<template>
    <v-container fluid class="my-0 px-0  py-0" v-if="tenantHasFeature('Support', current_tenant.ID)">
        <q-support-submenu has-demo="true" v-on:demo="startDemo()"></q-support-submenu>
        <!-- help and wayfinding -->
        <v-col cols="12" class="text-right mx-5 q-sticky-buffer">
            <!--
            <v-bottom-sheet v-model="sheet">
                <template v-slot:activator="{ on }">
                    <v-btn icon color="pink" v-on="on">
                        <v-icon>fas fa-question-circle</v-icon>
                    </v-btn>
                </template>
                <v-sheet class="text-left px-7" height="auto">
                    <div class="py-3" style="max-width:900px; margin:0 auto;">
                        <p class="q-display-2">Support</p>
                        <p>Support is designed to lead users through a set of answers to common questions related to their topic of inquiry. If the answer to their question isn't provided, they are then prompted to open a ticket which will be managed through Zendesk</p>
                        <v-btn class="mt-6" flat color="error" @click="sheet = !sheet">close</v-btn>
                    </div>
                </v-sheet>
            </v-bottom-sheet>
        -->
        </v-col>
        <!-- /help and wayfinding -->
        <v-row justify="space-between" align="start" class="mx-7">
            <v-col cols="12">
                <support-steps ref="support"></support-steps>
            </v-col>
        </v-row>
        <v-row justify="space-between" align="start" class="mx-7">
            <v-col cols="12">
                <page slug="service-status"></page>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
//table data + search
import QSupportSubmenu from '@/components/navigation/Submenus/QSupportSubmenu.vue';
import SupportSteps from './SupportSteps';
import Page from '@/CMS/views/index.vue'

export default {
    data() {
        return {
            search: '',
            sheet: false,
        }
    },
    mounted: function() {
        this.maybeAutoStartDemo('DemoSupport')
    },
    computed: {

    },
    methods: {
        'startDemo': function() {
            this.$tours['DemoSupport'].start()
        }
    },
    components: {
        SupportSteps,
        QSupportSubmenu,
        Page
    }
}
</script>
<style>
</style>